import { TextField, TextFieldProps } from "@mui/material";

interface Props extends TextFieldProps<"outlined"> {
  label?: string;
  required?: boolean;
}

export default function TextInput(props: Props) {
  const { id, label, required, ...rest } = props;
  return (
    <div className="flex w-full flex-col">
      {label && (
        <label className="field-label" htmlFor={id}>
          {label}
          {required && (
            <span className="text-red" aria-hidden="true">
              &nbsp;*
            </span>
          )}
        </label>
      )}
      <TextField
        slotProps={{
          input: {
            className: "!rounded-xl bg-white",
          },
          htmlInput: {
            className: "!px-4 !py-3",
            required: required || undefined,
          },
        }}
        fullWidth
        {...rest}
        id={id}
        variant="outlined"
      />
    </div>
  );
}
